"use strict";
/**
 * @file Created on 05.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var NotificationDoc_1 = require("../NotificationDoc");
/**
 * @author Tomas Leity
 */


var NThresholdSystemVolume =
/*#__PURE__*/
function (_NotificationDoc_1$No) {
  _inherits(NThresholdSystemVolume, _NotificationDoc_1$No);

  /**
   * @param productId
   * @param productName
   * @param productExternalId
   * @param systemVolume
   * @param systemVolumeOld
   * @param systemVolumeAbsDiff
   * @param systemVolumeRelDiff
   */
  function NThresholdSystemVolume(productId, productName, productExternalId, systemVolume, systemVolumeOld, systemVolumeAbsDiff, systemVolumeRelDiff) {
    var _this;

    _classCallCheck(this, NThresholdSystemVolume);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NThresholdSystemVolume).call(this));
    _this.productId = productId;
    _this.productName = productName;
    _this.productExternalId = productExternalId;
    _this.systemVolume = systemVolume;
    _this.systemVolumeOld = systemVolumeOld;
    _this.systemVolumeAbsDiff = systemVolumeAbsDiff;
    _this.systemVolumeRelDiff = systemVolumeRelDiff;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(NThresholdSystemVolume, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new NThresholdSystemVolume(mat.productId, mat.productName, mat.productExternalId, mat.systemVolume, mat.systemVolumeOld, mat.systemVolumeAbsDiff, mat.systemVolumeRelDiff);
    }
  }]);

  return NThresholdSystemVolume;
}(NotificationDoc_1.NotificationDoc);

exports.NThresholdSystemVolume = NThresholdSystemVolume;

NThresholdSystemVolume.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(NThresholdSystemVolume.name);
  return {
    productId: builder.id('productId'),
    productName: builder.str('productName'),
    productExternalId: builder.str('productExternalId'),
    systemVolume: builder.bigNum('systemVolume'),
    systemVolumeOld: builder.bigNum('systemVolumeOld'),
    systemVolumeAbsDiff: builder.bigNum('systemVolumeAbsDiff'),
    systemVolumeRelDiff: builder.bigNum('systemVolumeRelDiff')
  };
}();